import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import InputMask from 'react-input-mask';

import { parserInputValueDate, autoInputDate } from './helpers/helpers';
import { Button, Icon } from '../../../Elements';
import { textToDateDMY } from 'utils/common';

import classes from './HeaderDatePicker.module.scss';

const HeaderDatePicker = ({
  handleOpen,
  handleClear,
  placeholder,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  open,
  id
}) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (startDate) {
      setValue(textToDateDMY(startDate, endDate));
    } else {
      setValue('');
    }
    // eslint-disable-next-line
  }, [startDate, endDate]);

  useEffect(() => {
    const inputDate = parserInputValueDate(value);
    if (inputDate) {
      setStartDate(inputDate.start);
      setEndDate(inputDate.end);
    }
    // eslint-disable-next-line
  }, [value]);

  const onChangeInput = e => {
    setValue(autoInputDate(value, e.target.value));
  };

  const handleClearInput = () => {
    setValue('');
    handleClear();
  };

  return (
    <div
      className={cn(classes.header, open && classes.header_select)}
      onClick={handleOpen}
    >
      <InputMask
        className={classes.headerInput}
        placeholder={placeholder}
        maskChar={'_'}
        mask="99/99/9999 - 99/99/9999"
        onChange={onChangeInput}
        value={value}
        id={id}
      />

      <div className={classes.wrapControlButton}>
        {(startDate ||
          (value !== '__/__/____ - __/__/____' && value !== '')) && (
          <Button
            className={classes.clearWrap}
            onClick={handleClearInput}
            aria-label={`clear select`}
          >
            <Icon icon={'closeCircle'} className={classes.icon} size="16px" />
          </Button>
        )}

        <Icon icon="calendar" size="14px" color={'#3a5ba2'} />
      </div>
    </div>
  );
};

HeaderDatePicker.propTypes = {
  handleOpen: PropTypes.func.isRequired,
  handleClear: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  open: PropTypes.bool.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired
};

export default HeaderDatePicker;
